import httpClient from "./httpClient";

const base = "/dashboard";

export function getDashboardInfo() {
  return httpClient.get(`${base}/info`).then((res) => res.data.data);
}

export function getTotalStudent(academicYears) {
  // Repeated-key query string (academicYear=2025&academicYear=2026), not
  // axios's default academicYear[]=... bracket form — Tomcat rejects literal
  // (unencoded) square brackets in the raw request line with a 400 before
  // Spring's CORS filter ever runs, which the browser then reports as a
  // blocked CORS preflight rather than the real cause.
  const query = new URLSearchParams();
  (academicYears || []).forEach((year) => query.append("academicYear", year));
  return httpClient.get(`${base}/total-student${query.toString() ? `?${query.toString()}` : ""}`).then((res) => res.data.data);
}

export function getFathersProfessionSummary() {
  return httpClient.get(`${base}/fathers-profession-summary`).then((res) => res.data.data);
}

export function getClassWiseStudentSummary() {
  return httpClient.get(`${base}/class-wise-student-summary`).then((res) => res.data.data);
}
